import { render, staticRenderFns } from "./TrafficLight.vue?vue&type=template&id=4906b610&scoped=true&"
import script from "./TrafficLight.vue?vue&type=script&lang=js&"
export * from "./TrafficLight.vue?vue&type=script&lang=js&"
import style0 from "./TrafficLight.vue?vue&type=style&index=0&id=4906b610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4906b610",
  null
  
)

export default component.exports